import { render, staticRenderFns } from "./vueHistory.vue?vue&type=template&id=61c684a4&scoped=true"
import script from "./vueHistory.vue?vue&type=script&lang=js"
export * from "./vueHistory.vue?vue&type=script&lang=js"
import style0 from "./vueHistory.vue?vue&type=style&index=0&id=61c684a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c684a4",
  null
  
)

export default component.exports